import { getNavigation } from '@/lib/sanity/queries';

import { fetchCart } from '@/components/cart';
import { fetchStores } from '@/components/store';
import { StoreListing } from '@/components/store-listing';
import logger from '@/lib/utils/logger';

export async function getStaticProps() {
  const navigation = await getNavigation();

  try {
    const cart = await fetchCart();
    const stores = await fetchStores();

    return {
      props: {
        cart,
        stores,
        navigation,
      },
      revalidate: 60 * 60,
    };
  } catch (err) {
    logger.error(err);
  }

  return {
    props: {
      navigation,
    },
    revalidate: 60 * 60,
    notFound: true,
  };
}

export default StoreListing;
